export type VideoConstraints = {
  width?: { ideal: number } | number;
  height?: { ideal: number } | number;
  facingMode?: string;
};

const defaultVideoConstraints: VideoConstraints = {
  width: { ideal: 1920 },
  height: { ideal: 1080 },
  facingMode: 'user',
};

export interface CameraProps {
  videoConstraints?: VideoConstraints;
  onCapture: (imageSrc: string) => void;
  onClose: () => void;
}

export { defaultVideoConstraints };
